<template>
<div id="popup" v-if="popup_code != 0">
    <div class="popup-layer"></div>

    <div class="popup-wrap" v-if="popup_code == 1">
        <div class="popup-content popup-md">
            <div class="popup-body">
                <p class="popup-body-con">{{name}}</p>
            </div>
            <div class="popup-footer">
                <div class="btn-cancel one-btn" @click="close_popup"><span>닫기</span></div>
            </div>
        </div>
    </div>

    <div class="popup-wrap" v-if="popup_code == 2">
        <div class="popup-content table-popup">
            <div class="popup-head">
                <h3 class="seat-title">{{name}}</h3>
                <div class="btn-close" @click="close_popup">
                    <span class="bar"></span>
                    <span class="bar"></span>
                </div>
            </div>
            <div class="table-wrap">
                <table class="fee-table">
                    <colgroup>
                        <col width="25%" />
                        <col width="18%" />
                        <col width="23%" />
                        <col width="17%" />
                        <col width="17%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><span>상품명</span></th>
                            <th><span>이용시간</span></th>
                            <th><span>사용기간</span></th>
                            <th><span v-if="!store_info.card_only">현금</span></th>
                            <th><span>카드</span></th>
                        </tr>
                    </thead>                    
                    <tbody v-for="(item, index) in datas" :key="index">
                        <tr :key="idx" v-for="(info, idx) in item.info">
                            <template v-if="type !== 'LOCKER'">
                            <td>
                                <span class="blue">
                                    <template v-if="idx === 0">
                                        {{item.goods_name}}
                                        <template v-if="item.type_name.indexOf('(행사)') !== -1">
                                            (행사)
                                        </template>        
                                    </template>
                                </span>
                            </td>
                            </template>
                            <template v-else>
                            <td>
                                <span class="blue">
                                    <template v-if="idx === 0">{{info.goods_name}}</template>
                                    <template v-else-if="item.info[idx-1].goods_name != item.info[idx].goods_name">{{info.goods_name}}</template>
                                    <template v-else></template>
                                </span>
                            </td>
                            </template>
                            <td><span>{{info.use_time}}</span></td>
                            <!-- 250312 연장 문구 추가건으로 수정 -->
                            <!-- <td><span v-if="info.day_count !== null">{{info.day_count}}일</span></td> -->
                            <td>
                                <span v-if="type != 'SEAT' && info.day_count !== null">{{info.day_count}}일</span>
                                <span v-else-if="type == 'SEAT' && info.day_count !== null && info.day_continue == '0'">{{info.day_count}}일</span>
                                <span v-else-if="type == 'SEAT' && info.day_count !== null && info.day_continue == '1'">{{info.day_count}}일(연장)</span>
                            </td>

                            <!-- 코드 추가 - 2020-12-21 -->
                            <td class="price"><span v-if="!store_info.card_only">{{info.cash_amount}}</span></td>
                            <td class="price"><span>{{info.card_amount}}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="popup-wrap" v-if="popup_code == 3">
        <div class="popup-content">
            <div class="popup-head">
                <h3 class="seat-title"></h3>
                <div class="btn-close" @click="close_popup">
                    <span class="bar"></span>
                    <span class="bar"></span>
                </div>
            </div>
            <map-component ref="map" :map_type="'store'" />
        </div>
    </div>
    <div class="popup-wrap total-popup-wrap" v-if="popup_code == 4">
        <div class="popup-content table-popup">
            <div class="popup-head no-title">
                <div class="btn-close btn-total-close" @click="close_popup">
                    <span class="bar"></span>
                    <span class="bar"></span>
                </div>
            </div>
            <div class="tab-wrap total-tab-wrap">
                <div class="tab-header">
                    <ul>
                        <li data-tab="tab1" @click="choice_tab_click('SEAT')" :class="sel_tab == 'SEAT' ? 'active':''"><a href="javascript:void(0);">좌석</a></li>
                        <li data-tab="tab2" @click="choice_tab_click('GROOM')" :class="sel_tab == 'GROOM' ? 'active':''"><a href="javascript:void(0);">그룹룸</a></li>
                        <li data-tab="tab3" @click="choice_tab_click('LOCKER')" :class="sel_tab == 'LOCKER' ? 'active':''"><a href="javascript:void(0);">사물함</a></li>
                    </ul>
                </div>
                <div class="tab-body">
                    <ul>
                        <li id="tab1" :class="sel_tab == 'SEAT' ? 'active':''">
                            <div class="total-table-wrap table-wrap">
                                <table class="total-fee-table fee-table">
                                    <colgroup>
                                    <col width="20%" />
                                    <col width="18%" />
                                    <col width="16%" />
                                    <col width="16%" />
                                    <col width="15%" />
                                    <col width="15%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th><span>타입</span></th>
                                            <th><span>상품명</span></th>
                                            <th><span>이용시간</span></th>
                                            <th><span>사용기간</span></th>
                                            <th ><span v-if="!store_info.card_only">현금</span></th>
                                            <th><span>카드</span></th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(item, index) in datas.seat" :key="index">
                                        <tr :key="idx" v-for="(info, idx) in item.info">
                                            <td><span v-if="idx === 0">{{item.type_name}}</span></td>
                                            <td><span class="blue"><template v-if="idx === 0">{{item.goods_name}}</template></span></td>
                                            <td><span>{{info.use_time}}</span></td>
                                            <td>
                                                <!-- 250312 연장 문구 추가 -->
                                                <!-- <span v-if="info.day_count !== null">{{info.day_count}}일</span> -->
                                                 <span v-if="info.day_count !== null && info.day_continue == '0'">{{info.day_count}}일</span>
                                                <span v-else-if="info.day_count !== null && info.day_continue == '1'">{{info.day_count}}일(연장)</span>
                                            </td>
                                            <!-- 코드 추가 - 2020-12-21 -->
                                            <td class="price"><span v-if="!store_info.card_only">{{info.cash_amount}}</span></td>
                                            <td class="price"><span>{{info.card_amount}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li id="tab2" :class="sel_tab == 'GROOM' ? 'active':''">
                            <div class="total-table-wrap table-wrap">
                                <table class="total-fee-table fee-table">
                                    <colgroup>
                                    <col width="20%" />
                                    <col width="18%" />
                                    <col width="16%" />
                                    <col width="16%" />
                                    <col width="15%" />
                                    <col width="15%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th><span>타입</span></th>
                                            <th><span>상품명</span></th>
                                            <th><span>이용시간</span></th>
                                            <th><span>사용기간</span></th>
                                            <th><span v-if="!store_info.card_only">현금</span></th>
                                            <th><span>카드</span></th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(item, index) in datas.groom" :key="index">
                                        <tr :key="idx" v-for="(info, idx) in item.info">
                                            <td><span v-if="idx === 0">{{item.type_name}}</span></td>
                                            <td><span class="blue"><template v-if="idx === 0">{{item.goods_name}}</template></span></td>
                                            <td><span>{{info.use_time}}</span></td>
                                            <td><span v-if="info.day_count !== null">{{info.day_count}}일</span></td>
                                            <!-- 코드 추가 - 2020-12-21 -->
                                            <td class="price"><span v-if="!store_info.card_only">{{info.cash_amount}}</span></td>
                                            <td class="price"><span>{{info.card_amount}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li id="tab3" :class="sel_tab == 'LOCKER' ? 'active':''">
                            <div class="total-table-wrap table-wrap">
                                <table class="total-fee-table fee-table">
                                    <colgroup>
                                    <col width="30%" />
                                    <col width="30%" />
                                    <col width="20%" />
                                    <col width="20%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th><span>타입</span></th>
                                            <th><span>사용기간</span></th>
                                            <th><span v-if="!store_info.card_only">현금</span></th>
                                            <th><span>카드</span></th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(item, index) in datas.locker" :key="index">
                                        <tr :key="idx" v-for="(info, idx) in item.info">
                                            <td><span class="blue">
                                                <template v-if="idx === 0">{{info.type_name}}</template>
                                                <template v-else-if="item.info[idx-1].type_name != item.info[idx].type_name">{{info.type_name}}</template>
                                                <template v-else></template>
                                                </span></td>
                                            <td><span v-if="info.day_count !== null">{{info.day_count}}일</span></td>
                                            <!-- 코드 추가 - 2020-12-21 -->
                                            <td><span class="price" v-if="!store_info.card_only">{{info.cash_amount}}</span></td>
                                            <td><span class="price">{{info.card_amount}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- 나의매장으로 등록하기 pop -->
    <div class="popup-wrap" v-if="popup_code == 99">
        <div class="popup-content popup-md">
            <div class="popup-head">
                <p class="popup-title"><img src="../../assets/images/menu_05.png" alt="" class="icon-mystore"><span>나의 매장</span>으로 등록하기</p>
            </div>
            <div class="popup-body">
                <div class="popup-input">
                    <input type="password"  name="user_password" :maxlength="4" @keypress="isNumber($event)" placeholder="키오스크 비밀번호 입력" v-model="password_fr">
                    <p v-if="chk_password_fr" style="color:red">비밀번호가 일치하지 않습니다. </p>
                </div>
            </div>
            <div class="popup-footer">
                <div class="btn-register" @click="set_mystore"><span>확인</span></div>
                <div class="btn-cancel" @click="close_popup"><span>닫기</span></div>
            </div>
        </div>
    </div>
    <!-- 신규매장가입 하기 pop -->
    <div class="popup-wrap" v-if="popup_code == 100">
        <div class="popup-content popup-md">
            <div class="popup-head">
                <p class="popup-title"><img src="../../assets/images/menu_05.png" alt="" class="icon-mystore">매장출입 비밀번호 생성</p>
            </div>
            <div class="popup-body">
                <div class="popup-input">
                    <input type="password" :maxlength="4" @keypress="isNumber($event)" name="user_password" placeholder="Password" v-model="password_fn" full_length="4">
                    <input type="password" :maxlength="4" @keypress="isNumber($event)" name="user_password_chk" placeholder="비밀번호 확인" v-model="password_fn_sub" full_length="4">
                    <p style="color:red" v-if="chk_password_fn">비밀번호가 일치하지 않습니다. </p>
                </div>
            </div>
            <div class="popup-footer">
                <div class="btn-register" @click="registe_new_store"><span>확인</span></div>
                <div class="btn-cancel" @click="close_popup"><span>닫기</span></div>
            </div>
        </div>
    </div>

    <div class="popup-wrap" v-if="popup_code == 101">
        <div class="popup-content popup-md">
            <div class="popup-body popup-alert">
                <p class="popup-body-con"><img src="../../assets/images/menu_05.png" alt="" class="icon-mystore"><span>나의 매장</span>으로 등록 되었습니다.</p>
            </div>
            <div class="popup-footer">
                <div class="btn-cancel" @click="close_popup"><span>닫기</span></div>
            </div>
        </div>
    </div>

    <div class="popup-wrap" v-if="popup_code == 102">
        <div class="popup-content popup-md">
            <div class="popup-body">
                <p class="popup-body-con">해당매장에 회원가입이 완료되었습니다.<br>해당매장을 <span>나의 매장</span>으로 등록하시겠습니까?</p> 
            </div>
            <div class="popup-footer">
                <div class="btn-register" @click="popup_code = 99"><span>확인</span></div>
                <div class="btn-cancel" @click="close_popup"><span>닫기</span></div>
            </div>
        </div>
    </div>

    <div class="popup-wrap" v-if="popup_code == 103">
        <div class="popup-content popup-md">
            <div class="popup-body">
                <p class="popup-body-con" v-html="txtMessage"></p>
            </div>
            <div class="popup-footer">
                <div class="btn-cancel one-btn" @click="close_popup"><span>닫기</span></div>
            </div>
        </div>
    </div>

    <div class="popup-wrap" v-if="popup_code == 104">
        <div class="popup-content popup-md">
            <div class="popup-body">
                <p class="popup-body-con" v-html="txtMessage"></p>
            </div>
            <div class="popup-footer">
                <div class="btn-delete" @click="user_delete"><span>확인</span></div>
                <div class="btn-cancel one-btn" @click="close_popup"><span>닫기</span></div>
            </div>
        </div> 
    </div>

</div>
</template>

<script>

import MapComponent from '../component/MapComponent';
import EventBus from '../../js/event_bus';
import * as config from '../../js/config';
import common from '../../js/common';
export default {
    name: "popup",
    components: {
        'map-component': MapComponent
    },
    data() {
        return {
            message: '',
            popup_code: 0,
            router: '',
            image_type: '',
            name: '',
            type: '',
            datas: [],
            //나의매장으로 등록하기에 사용되는 비밀번호
            password_fr:'',
            chk_password_fr:false,
            //신규매장가입하기 에 사용되는 비밀번호
            password_fn:'',
            password_fn_sub:'',
            chk_password_fn:false,
            sel_tab: 'SEAT',
            txtMessage:'',
            store_info: {}
        }
    },
    created() {
        EventBus.$on('popup-data', (data) => {
            this.popup_code = data.code;
            this.name = data.name;
            this.type = data.type;
            this.datas = data.res;
            if (data.store_info){
                this.store_info = data.store_info;
            }
            if(this.popup_code == 103 || this.popup_code == 104){                
                this.txtMessage = data.message; 
            }
        });
    },
    mounted() {
    },
    watch: {
        popup_code() {
            if(this.popup_code == 99){
                this.password_fr='';
                this.chk_password_fr=false;
            }else if(this.popup_code == 100){
                this.password_fn='';
                this.password_fn_sub='';
                this.chk_password_fn=false;
            }
        }
    },
    methods: {
        isNumber(evt){                        
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;            
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        close_popup() {            
            if(this.popup_code == 101){
                var data;
                EventBus.$emit('popup_close', data);
            }else if(this.popup_code == 4){ // 탭 테이블 팝업을 닫았을때
                this.sel_tab = 'SEAT';
            }           
            this.popup_code = 0;
            document.body.classList.remove('modal-open');
        },
        destroyed(){
            EventBus.$off('popup-data');
        },
        set_mystore() {
            var data = {};
            var user_info = this.$store.getters['getUser_info'];
            var store_id = this.$store.getters['getDetail_sel_store_id'];           
            data.m_user_id = user_info.value.m_user_id;
            data.store_id = store_id.value;
            data.password = this.password_fr;
            data.user_hp = user_info.value.user_hp;
            var type = config.REQ_SET_MYSTORE;
            common.getData(type, data,
                (response) => {                    
                    if(response.res_result){
                        this.popup_code = 101;
                    }else{
                        this.chk_password_fr = true;
                    }
                })
        },
        registe_new_store(){            
            if(this.password_fn != this.password_fn_sub){
                this.chk_password_fn = true;
                return;
            }
        
            var data = {};
            var user_info = this.$store.getters['getUser_info'];
            var store_id = this.$store.getters['getDetail_sel_store_id'];           
            data.m_user_id = user_info.value.m_user_id;
            data.store_id = store_id.value;
            data.password = this.password_fn;
            data.user_hp = user_info.value.user_hp;
            data.name = user_info.value.name;
            data.parents_hp = user_info.value.parents_hp;
            var type = config.REQ_REGISTE_NEWSTORE;
            common.getData(type, data,
                (response) => {
                    if(response.result){
                        this.popup_code = 102;
                        var data;
                        EventBus.$emit('popup_close', data);
                    }else{
                        //회원가입이 이미되어있음
                    }
                })
        },
        user_delete(){            

            var data = {};
            var user_info = this.$store.getters['getUser_info'];
            var store_id = this.$store.getters['getDetail_sel_store_id'];           
            data.m_user_id = user_info.value.m_user_id;
            data.store_id = store_id.value;
            data.password = this.password_fn;
            data.user_hp = user_info.value.user_hp;
            data.name = user_info.value.name;
            data.parents_hp = user_info.value.parents_hp;

            var type = config.REQ_INFO_DELETE; 
            common.getData(type, data,
                (response) => {
                    if(response.result){
                        var data = { 
                            code: 103,
                            message: '정상적으로 탈퇴되었습니다.'
                        };     
                        EventBus.$emit('popup-data', data);
                    }

                    this.$router.push('/');
                    var data = {
                        m_user_id: '',
                        name: '',
                        user_hp: '',
                        parents_hp: '',
                        memo: '',
                        agree_yn: '',
                        join_datetime: '',
                        age: '',
                        sex: ''
                    }

                    this.$store.commit('setUser_info', {
                        value: data
                    });
                    this.$store.commit('setLogin_chk', {
                        value: false
                    });
  
                    common.removeAutoLoginSetting();
                })
        },
        choice_tab_click(type){
            this.sel_tab = type;
        }

    },
}
</script>



// WEBPACK FOOTER //
// src/components/component/PopupComponent.vue